import React, { useEffect, useRef, useState } from 'react';
import { searchLocations } from '../../services/geoAdminService';
import type {IRoofAddress, SearchLocation} from '../../react-app-env';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { fullpageApi } from "@fullpage/react-fullpage";
import ErrorIndicator from "../ErrorIndicator";




interface AddressSearchProps {
    mapRef: any
    typeaheadRef: any
    i18nMap: any
    fullpageApi: fullpageApi
    onSelect: (location: SearchLocation | null) => void // Callback function prop
    hasError: boolean
    tabIndex: number
    defaultSearchValue?: SearchLocation | null
    clearOnSearch: boolean
    handleCurrentInputChange: any
    selectedDraft: IRoofAddress
    disableFields: boolean
    addressChanged?: boolean
}

export default ({ mapRef, typeaheadRef, i18nMap, defaultSearchValue, clearOnSearch, fullpageApi, onSelect, hasError, tabIndex, handleCurrentInputChange, selectedDraft, disableFields, addressChanged, }: AddressSearchProps) => {
    const classList = ['address-search-holder', 'address-search-input', 'options-holder', 'address-opt'];

    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState<SearchLocation[]>([]);

    const [isFocused, setIsFocused] = useState(false);

    const [showOptions, setShowOptions] = useState(false);


    

    const handleSearch = (query: string) => {
        setIsLoading(true);
        searchLocations(query, i18nMap.lang).then((data) => {
            setOptions(data);
            setIsLoading(false);
        })
    };

    const handleTyping = (e: any) => {
        handleCurrentInputChange(e.target.value);

        if(e.target.value?.length > 3) {
            setShowOptions(true);
            handleSearch(e.target.value);
        } else {
            setShowOptions(false);
        }
    }

    const highlightMatch = (text: string, query: string) => {
        if (!query) return text;
        const regex = new RegExp(`(${query})`, 'gi');
        return text.split(regex).map((part, index) =>
            regex.test(part) ? <span key={index} className="highlight">{part}</span> : part
        );
    };
    
    // Inside return statement
   
    

    const selectOption = (opt: SearchLocation) => {
        onSelect(opt);

        setOptions([]);
        fullpageApi.setAllowScrolling(true);
        setIsFocused(false);
        setShowOptions(false);

        handleCurrentInputChange(opt.cleanLabel);
    }

    // Scroll lock is handled by onFocus/onBlur and selectOption — no effect needed

    useEffect(() => {
        const handleMouseDown = (e: any) => {
            const elementClassList = e.target.classList;
            const isExcluded = !classList.some(className => elementClassList.contains(className));

            if (isExcluded) {
                setShowOptions(false);
                setOptions([]);
            }
        };

        document.addEventListener('mousedown', handleMouseDown);
        return () => document.removeEventListener('mousedown', handleMouseDown);
    }, []);

    const showInitialGlow = !isFocused && !selectedDraft.searchAddress?.cleanLabel && !disableFields;
    const showAddressChangedGlow = addressChanged && !disableFields;

    return (
        <div className={`${classList[0]} ${disableFields && 'disabled'} ${showInitialGlow ? 'address-search-glow' : ''} ${showAddressChangedGlow ? 'address-changed-glow' : ''}`}>
            <i className="fa fa-search fa-lg search-icon"></i>

            <input
                ref={typeaheadRef}
                spellCheck={false}
                type={'text'}
                placeholder={i18nMap.searchForAddress}
                className={classList[1]}
                value={selectedDraft.currentInput || ''}
                onChange={handleTyping}
                onFocus={() => {
                    fullpageApi.setAllowScrolling(false);
                    setIsFocused(true);
                }}
                onBlur={(e) => {
                    fullpageApi.setAllowScrolling(true);
                    setIsFocused(false);
                }}
                disabled={disableFields}
            />

            {hasError && <ErrorIndicator error={i18nMap.pleaseEnter}/>}

            <div
                className={`indicate-location-icon non-selectable ${disableFields && 'disabled'}`}
                onClick={() => !disableFields && mapRef?.current?.geoLocation()} title={i18nMap.indicateLocation}
            >
                <div className={`indicate-location-icon-inner`}></div>
            </div>

            {showOptions && (
    <div className={classList[2]}>
        {options.map((opt, key) => (
            <div key={key} className={classList[3]} onClick={() => selectOption(opt)}>
                {highlightMatch(opt.cleanLabel, selectedDraft.currentInput || '')}
            </div>
        ))}
    </div>
)}
        </div>
    );
}